module.exports = __webpack_public_path__ + "static/media/banner-welcomebonus-web.bfc679ad.jpg";